const pt = {
  headerComponent: {
    home: "Início",
    aboutUs: "Sobre nós",
    plans: "Planos",
    contact: "Contato",
    login: "Login",
    register: "Criar Conta",
    adm: {
      priceList: "Tabelas de Preços",
      reservations: "Reservas",
      users: "Usuários",
    },
    isntMobile: {
      isStoreOwner: {
        reservations: "Reservas",
        property: "Imóveis",
        subscription: "Assinatura",
      },
      isAuthenticated: {
        settings: "Configurações",
        explanatoryVideos: "Vídeos explicativos",
        logOut: "SAIR",
      },
    },
  },

  register: {
    createAccount: "Criar conta",
    welcome: "Bem vindo ao Selfie Check-in!",
    welcomeMessage:
      "Estamos animados para ter você conosco. Para criar sua conta é simples e rápido: preencha os campos abaixo e o nosso consultor entrará em contato com você!",
    yourData: "Seus Dados",
    name: "Nome",
    fullNameRequired: "Nome completo é obrigatório",
    email: "E-mail",
    emailRequired: "E-mail é obrigatório",
    invalidEmail: "E-mail inválido",
    phone: "Telefone (WhatsApp)",
    phoneRequired: "Telefone é obrigatório",
    invalidPhone: "Telefone inválido",
    companyName: "Nome da Empresa",
    companyNameRequired: "Nome da Empresa é obrigatorio",
    cnpj: "CNPJ",
    website: "Site",
    invalidWebsite: "Site inválido",
    cnpjRequired: "CNPJ é obrigatório",
    createPassword: "Crie uma senha",
    passwordRequired: "Senha é obrigatória",
    confirmPassword: "Confirme sua senha",
    confirmPasswordRequired: "Confirmação de senha é obrigatória",
    emailRegistered: "Email já cadastrado",
    finishRegister: "Finalizar Cadastro",
    back: "Voltar",
    skipSubscription: "Não desejo fazer a assinatura agora",
    passwordMismatch: "As senhas devem corresponder",
    minPasswordLength: "A senha deve ter no mínimo 6 caracteres",
    quantityRequired: "A quantidade de propriedades é obrigatória",
    quantityMustBeNumber: "A quantidade de propriedades deve ser um número",
    minQuantity: "Mínimo de propriedades é 1",
    maxQuantity: "Máximo de propriedades é 1000",
  },

  wait: {
    thankYou: "Obrigado!",
    waitTitle: "Aguarde",
    waitMessage:
      "Estamos processando suas informações. Em breve entraremos em contato com você para dar continuidade ao atendimento.",
    callToAction: "Voltar para o inicio",
  },

  plans: {
    defaultErrorMessage: "Erro ao buscar tabela de preços",
    errorAlert: "Nenhuma tabela encontrada até o momento. Tente novamente.",
    pageName: "Planos",
    title: "Encontre o plano perfeito para você",
    you: "você.",
    text: "Arraste a barra abaixo para informar o seu número de propriedades",
    selectedProperties: "Propriedades selecionadas",
    selectedProperty_1: "Propriedade selecionada",
    perfectForYou: "Perfeito para você",
    month: "mês",
    perProperty: "Por propriedade nesta faixa",
    planFor: "Plan for ",
    to: "a ",
    properties: " propiedades",
    continue: "Prosseguir",
    tiersNotice:
      "A cobrança é progressiva: o preço de cada faixa vale para os imóveis que entram naquela faixa, e as faixas se somam para formar a sua mensalidade.",
    monthlyTotal: "Sua mensalidade",
    averagePerProperty: "Equivale a {price} por propriedade",
    breakdownTitle: "Como chegamos nesse valor",
    propertySingle: "Imóvel {n}",
    propertyRange: "Imóveis {from} a {to}",
    fromPropertyOnwards: "{from} propriedades ou mais",
    quoteError: "Não foi possível calcular a mensalidade. Tente novamente.",
  },

  fetchWrapper: {
    notConnectServer:
      "Não foi possível conectar ao servidor. Por favor, tente novamente mais tarde.",
    internalServerError:
      "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
  },

  contact: {
    contact: "Contato",
    title: "Entre em contato conosco",
    caption:
      "Estamos aqui para ajudar e responder suas dúvidas. Preencha o formulário abaixo ou envie uma mensagem diretamente.",
    fields: {
      name: "Nome",
      email: "E-mail",
      phone: "Telefone (Whatsapp)",
      subject: "Assunto",
      message: "Escreva sua mensagem",
      submit: "Enviar mensagem",
    },
    text: "Nós otimizamos seu processo de reservas para proporcionar a experiência tranquila e eficiente que você e seus hóspedes merecem!",
    validation: {
      name: "Nome é obrigatório",
      email: {
        required: "E-mail é obrigatório",
        invalid: "E-mail inválido",
      },
      phone: "Telefone é obrigatório",
      subject: "Assunto é obrigatório",
      message: "Mensagem é obrigatória",
    },
    hubspotForm: {
      fields: {
        firstname: "Nome",
        companyName: "Nome da empresa",
        email: "E-mail",
        phone: "Telefone",
        propertiesCount: "Quantos imóveis/quartos administra?",
        usesChannelManager: "Usa Channel manager?",
        whichChannelManager: "Se sim, qual?",
        submit: "Enviar",
      },
      options: {
        yes: "Sim",
        no: "Não",
        other: "Outro",
      },
      validation: {
        firstname: "Informe o seu nome",
        companyName: "Informe o nome da empresa",
        email: {
          required: "Informe o email",
          invalid: "Informe um email válido",
        },
        phone: "Informe o telefone",
        propertiesCount: "Informe quantos imóveis/quartos administra",
        channelManagerUsage: "Informe se usa channel manager",
        whichChannelManager: "Informe qual channel manager usa",
      },
    },
    success: "Formulário enviado com sucesso!",
    captcha: {
      required: "Confirme que você não é um robô.",
      unavailable: "Captcha não configurado no momento.",
    },
    error: {
      generic: "Erro ao enviar formulário",
    },
  },

  login: {
    welcomeBack: "Bem vindo de volta!",
    text: "Faça login para acessar sua conta e continuar aproveitando todas as vantagens que oferecemos. É rápido, fácil e estamos aqui para ajudar, caso precise!",
    password: "Senha",
    submit: "Entrar",
    forgotPassword: "Esqueceu sua senha?",
    error: {
      email: "Email é obrigatório",
      password: "Senha é obrigatório",
      login: "Erro ao fazer login: ",
    },
  },

  aboutUs: {
    title: "SOBRE NÓS",
    subtitleSpan: "Nós transformamos sua ",
    subtitle: "experiência de hospedagem",
    text: "Trazemos inovação e segurança para cada etapa do processo. Com tecnologia de ponta e um toque de praticidade, tornamos cada estadia mais segura, ágil e confiável",
    connected: {
      title: "Conectado",
      textBrLeft: "Integrado com as principais",
      textBrRight: "plataformas de hospedagem.",
    },
    secure: {
      title: "Seguro",
      text: "Não se preocupe, todos os dados são autenticados diretamente no Gov.br.",
    },
    userFriendly: {
      title: "Descomplicado",
      text: "Oferece mais praticidade e conveniência para você e seus hóspedes.",
    },
    content1: {
      title:
        "A Selfie Check-in surgiu da necessidade de anfitriões de aluguel de temporada que buscavam maior segurança e confiabilidade na verificação da documentação dos inquilinos.",
      text: "Vivendo na pele os desafios de conciliar um processo de reservas eficiente com uma experiência rápida e prática para os hóspedes, entendemos as dificuldades do dia a dia.",
    },
    content2: {
      title:
        "Sabemos que a segurança do imóvel é uma prioridade para todo anfitrião,",
      text: "mas o processo de solicitação, conferência e upload dos documentos em diferentes plataformas pode sobrecarregar a equipe e frustrar os hóspedes. Com isso em mente, desenvolvemos um software que realiza a verificação cruzada de informações e documentos, assegurando a autenticidade dos dados de forma simples, ágil e descomplicada.",
    },
    caption:
      "Nós otimizamos seu processo de reservas para proporcionar a experiência tranquila e eficiente que você e seus hóspedes merecem!",
  },

  footerComponent: {
    title: "Não perca tempo! Pare de se preocupar com a burocracia.",
    freeTrialLink: "Experimente 30 dias grátis",
    contact: "Contato",
    allRights: "Todos os Direitos Reservados",
  },

  reload: "Recarregar",
  towHours: "Este campo estará visível 2 horas antes do check-in.",
  edit: "Editar",
  create: "Cadastrar",
  stay: "Estadia",
  yourStay: "Sua Estadia",
  welcome: "Bem-vindo",
  addressD: "Endereço",
  earlyCheck: "Check-in antecipado",
  reqLate: "Solicitar Check-Out Tardio",
  mobCheck: "Check-Out Móvel",
  rebook: "Reserve Novamente Diretamente & Economize",
  homeGuide: "Guia do imóvel",
  homeD: "Tour pela Casa",
  inventory: "Inventário/Kits de Início",
  coffeM: "Cafeteiras",
  tv: "Instruções da TV",
  freezer: "Geladeira/Freezer",
  cooling: "Aquecimento & Resfriamento",
  laundry: "Lavanderia",
  trash: "Lixo",
  pool: "Piscina",
  hotTub: "Banheira de Hidromassagem",
  doorCode: "Código da Porta",
  areaGuide: "Guia da Área",
  clearSky: "Céu limpo",
  mainlyClear: "Principalmente limpo",
  partlyCloudy: "Parcialmente nublado",
  overcast: "Encoberto",
  fog: "Nevoeiro",
  drizzle: "Garoa",
  freezingDrizzle: "Garoa congelante",
  rain: "Chuva",
  freezingRain: "Chuva congelante",
  snow: "Neve",
  snowGrains: "Grãos de neve",
  rainShowers: "Aguaceiros",
  snowShowers: "Chuva de neve",
  thunderstorm: "Trovoada",
  thunderstormHail: "Trovoada com granizo",
  unknown: "Desconhecido",
  weatherLoading: "Obtendo dados de previsão do tempo...",
  weatherError: "Não foi possível obter a previsão do tempo.",
  nearBy: {
    mapUpdated: "Mapa atualizado para a localização selecionada",
    addressCopied: "Endereço copiado com sucesso!",
    restaurant: "Restaurante",
    bar: "Bar",
    market: "Mercado",
    bakery: "Padaria",
    pharmacy: "Farmácia",
    mall: "Shopping",
    bank: "Banco",
    theater: "Teatro",
    cinema: "Cinema",
    museum: "Museu",
    park: "Parque",
    tourist_spot: "Ponto Turístico",
    beach: "Praia",
    stadium: "Estádio",
    subway_train: "Metrô / Trem",
    other: "Outro",
    gym: "Academia",
    auditorium: "Auditório",
    bars: "Bares",
    library: "Biblioteca",
    boutique: "Boutique & Lojas de Moda",
    atm: "Caixas Eletrônicos & Casas de Câmbio",
    cafe: "Café",
    show_house: "Casas de Show & Espetáculos",
    cultural_center: "Centros Culturais",
    convention_center: "Centros de Convenções",
    clinic: "Clínicas & Hospitais",
    coworking: "Co-workings",
    sweet_shop: "Doceria",
    event_space: "Espaço para Eventos",
    handicraft_fair: "Feira de Artesanato",
    food_truck: "Food Trucks",
    art_gallery: "Galerias de Arte",
    laundry: "Lavanderia",
    car_rental: "Locação de Carros & Bicicletas",
    convenience_store: "Lojas de Conveniência",
    souvenir_store: "Lojas de Souvenirs",
    open_market: "Mercados & Feiras Livres",
    flea_market: "Mercados de Pulgas",
    viewpoint: "Mirantes & Pontos Turísticos",
    gas_station: "Posto de Gasolina",
    boat_tour: "Passeios de Barco & Esportes Aquáticos",
    salon: "Salão de Beleza & Barbearia",
    transport_services: "Serviços de Transporte (Táxis, Uber, etc.)",
    ice_cream_shop: "Sorveteria",
    spa: "Spas & Centros de Massagem",
    trails: "Trilhas & Caminhadas",
    winery: "Vinícolas & Cervejarias Artesanais",
    yoga: "Yoga & Meditação",
    university: "Universidade",
    airport: "Aeroporto",
    parking: "Estacionamento",
  },
  nameLabel: "Nome do Local",
  cepLabel: "CEP",
  streetLabel: "Rua",
  numberLabel: "Número",
  typeLabel: "Tipo do Local",
  complementLabel: "Complemento (Opcional)",
  neighborhoodLabel: "Bairro",
  cityLabel: "Cidade",
  stateLabel: "Estado",
  addPlace: "Adicionar Local",
  nearbyPlaces: "Locais Próximos",
  cuisine: "Cozinha",
  establishment: "Estabelecimento",
  details: "Ver detalhes",
  zipError: "Erro ao buscar CEP",
  lang: "pt_BR",
  failedFetchLivenessSession: "Falha ao iniciar prova de vida",
  failedCheckLivenessSession:
    "Resultado da prova de vida inconsistente. Tente novamente.",
  cutImage: "Recorte a imagem",
  rotateImage: "Rotacionar",
  saveCut: "Salvar",
  saveAdditionalGuest: "Salvar",
  maxGuestsReached: "Número máximo de hóspedes atingido!",
  cancelCut: "Cancelar",
  infoForGuests:
    "Você pode preencher os dados dos demais hóspodes ou enviar o link para eles preencherem",
  guestAlreadyRegisteredWarning:
    "O hóspede já cadastrado anteriormente não deve ser adicionado como hóspede adicional.",
  noAdditionalGuests: "Nenhum hóspede adicional cadastrado",
  wasRefused:
    "Seu preenchimento da reserva precisa de ajustes. Revise o(s) seguinte(s) ponto(s)",
  property: "Propriedade",
  back: "Voltar",
  reservationCode: "Código da Reserva",
  errorLoad: "Erro ao carregar dados. Tente novamente",
  hi: "Olá",
  close: "Fechar",
  chooseOptionBelow: "Opções para você",
  inAnalysis: "Em análise",
  accessToPlace: "Acesso ao local",
  fillData: "Preencher dados pessoais",
  contactUs: "Dúvidas? Fale conosco",
  seeDetails: "Ver detalhes da acomodação",
  reservationInApproval: "Reserva em aprovação",
  waitingApproval:
    "<strong>Sua reserva está em aprovação.</strong> Assim que finalizada, todos detalhes de acesso e sobre a acomodação estarão disponíveis aqui.",
  reservationRefused: "Seu formulário precisa de revisão",
  reservationDetails: "Endereço completo, acessos, senhas, regras e dicas.",
  advertiseNavigateThroughNextAndBackButtons:
    "Para navegar pelas abas, utilize os botões próximo e voltar abaixo",
  filled: "FORMULÁRIO EM ANALISE OU FINALIZADO!",
  CodeCopy: "Código copiado com sucesso!",
  AddressCopy: "Endereço copiado com sucesso!",
  loading_indicator: "Carregando dados, por favor, aguarde!",
  step1: "Estadia",
  step2: "Dados do(a) hóspede <br/> titular da reserva",
  step3: "Hóspedes Adicionais",
  step4: "Caução",
  step4AdditionalMode: "Seus Dados",
  step5: "Documento do(a) hóspede <br/> titular da reserva",
  name: "Nome completo do Hóspede",
  cpf: "CPF",
  foreignDocument: "Documento (Passaporte, RNE)",
  isForeign: "estrangeiro?",
  isInternational: "internacional?",
  changeCheckinAndCheckoutTime:
    "Para alterar datas e horários da estadia, entre em contato com o suporte por meio do whatsapp, clique aqui.",
  email: "E-mail do hóspede",
  phone: "Telefone do hóspede",
  phone_whats: "Telefone do hóspede (WhatsApp)",
  birthDate: "Data de nascimento",
  address: "Endereço do hóspede",
  cep: "CEP",
  postalCode: "Código Postal",
  country: "País",
  city: "Cidade",
  state: "Estado",
  number: "Número",
  addressLine1: "Linha de Endereço 1",
  addressLine2: "Linha de Endereço 2",
  street: "Rua",
  obs: "Complemento",
  residenceShortAddress: "Local",
  checkInDate: "Data de check-in",
  checkInTime: "Horário de check-in",
  checkOutDate: "Data de check-out",
  checkInTimeSelector: "Selecione horário de checkin",
  checkOutTime: "Horário de check-out",
  checkOutTimeSelector: "Selecione horário de checkout",
  checkinCheckoutTimeSelectorClose: "Fechar",
  visitPurpose: "Propósito da visita",
  havePets: "Tem animal de estimação?",
  bringPets: "Animais de estimação",
  bringPets_hint:
    "Esse campo é somente para imóveis que permitem animais de estimação.",
  adults: "Número de adultos",
  adults_info:
    "Este número corresponde ao total de adultos que estão preenchendo o formulário ou que estão fazendo a reserva.",
  children: "Número de crianças",
  submit: "ENVIAR DADOS",
  prev: "Voltar",
  next: "Próximo",
  cancel: "Cancelar",
  yes: "Sim",
  no: "Não",
  noData: "Nenhum dado para exibir",
  noAirbnb: "Sem caução, reserva via Airbnb",
  chooseCaptureMethod: "Escolha uma opção",
  captureOrUpload: "Tirar foto",
  attachFile: "Anexar Arquivo",
  sendFile: "Enviar Arquivo",
  changeFile: "Trocar Arquivo",
  submitSuccess: "Dados enviados com sucesso. Entraremos em contato em breve.",
  submitSuccessAdditional: "Dados enviados com sucesso.",
  failedLoadReservation: "Falha ao carregar dados da reserva",
  submitError: "Erro ao salvar dados. Tente novamente.",
  errors: {
    STAYS_DUPLICATED_EMAIL:
      "Erro: 453534 - Email Duplicated - Contatar suporte.",
  },
  errorLoadingForm: "Erro ao carregar os dados. Tente novamente.",
  description: "Descrição",
  allAlright: "Tudo certo por enquanto, aguarde a liberação de acesso",
  justMainGuestCanFill:
    "Atenção, apenas o hóspede principal da reserva deve preencher esse link.",
  // ----------validationSchema----------
  visitPurposes: {
    leisure: "Lazer - Férias",
    work: "Negócios",
    shopping: "Compras",
    familyFriends: "Parentes - Amigos",
    congressFair: "Congresso - Feira",
    course: "Estudo - Cursos",
    healthTreatment: "Saúde",
    religion: "Religião",
    other: "Outro",
    notInformed: "Não informado",
  },
  dontInformPurpose: "Não desejo informar o propósito da visita",
  termsConfirmation:
    "Ao continuar, você declara que leu e aceita os nossos termos de privacidade e segurança de dados",
  termsAcceptanceTitle: "Aceitar Termos de Uso E Políticas de Privacidade",
  termsAcceptanceMessage:
    "Para prosseguir com o preenchimento, é necessário aceitar nossos termos de uso e políticas de privacidade.",
  termsCheckboxLabel: "Eu li e aceito os {link}",
  imageTermsCheckboxLabel: "Eu aceito os {link}",
  imageTermsOfUse: "termos de uso de imagem",
  imageTermsTitle: "Termos de uso de imagem",
  userTermsCheckboxLabel: "Eu li e aceito os {link}",
  userTermsOfUse: "Termos de uso {companyName}",
  userTermsTitle: "Termos de uso {companyName}",
  doNotAccept: "Não aceitar",
  continueButton: "Continuar",
  mustAcceptTerms: "Você deve aceitar os termos para continuar",
  readDocumentsMessage: "Para continuar, leia nossos documentos:",
  termsOfUse: "Termos de Uso",
  privacyPolicyLink: "Política de Privacidade",
  areYouSureYouWantToExclude: "Você deseja realmente remover {ref}?",
  withVehicle: "Planeja vir com um veículo?",
  addVehicle: "Adicionar Veículo",
  removeVehicle: "Remover Veículo",
  vehicleType: "Tipo de Veículo",
  vehicleIndex: "Veículo nº",
  vehicleTypeCar: "Carro",
  vehicleTypeMotorcycle: "Moto",
  vehicleLicensePlate: "Modelo, Cor e Placa do Veículo",
  residenceWithNoGarages: "Este imóvel não possui estacionamento incluso",
  residenceWithLimitedGarages:
    "Este imóvel inclui estacionamento para até {count} veículo{suffix}",
  at: "às",
  fillCheckinTime: "Por favor, preencha a data de entrada",
  fillCheckoutTime: "Por favor, preencha a data de saída",
  guestRegister: "Cadastro do hóspede",
  sections: {
    guestData: "Dados do hóspede titular da reserva",
    termsAndConditions: "Termos e condições",
    documents: "Documentos do hóspede titular",
    documentsSubtitle: "Adicione foto do RG, CNH ou passaporte",
    additionalGuests: "Dados dos acompanhates",
    additionalGuestSpecific: "Dados do acompanhante {nameOrIndex}",
    stayDetails: "Dados da estadia",
    stayDetailsSubtitle: "Preencha com os dados da estadia",
  },

  formSteps: {
    stayData: "Dados da estadia",
    fillStayData: "Preencha com os dados da estadia",
    checkinTime: "Horário de check-in",
    checkoutTime: "Horário de check-out",
    arrivalLabel: "Horário previsto de chegada (check-in)",
    arrivalNotice:
      "Informe a previsão exata dos seus horários de chegada e de saída. Isso ajuda o anfitrião a preparar sua recepção.",
    arrivalHint: "Previsão exata de chegada",
    departureLabel: "Horário previsto de saída (check-out)",
    departureHint: "Previsão exata de saída",
    confirm: "Confirmar",
    visitPurpose: "Propósito da visita",
    cars: "Carros",
    vehicle: "Veículo",
    vehicleType: "Tipo de veículo",
    vehiclePlate: "Modelo/Placa/Cor do veículo",
    noGarageWarning: "Essa hospedagem não aceita carros",
    pets: "Pets",
    pet: "Pet",
    petType: "Tipo de animal (ex: Cachorro, Gato)",
    noPetsWarning: "Essa hospedagem não aceita pets",
    addAnimal: "Adicionar animal",
    addAnimalInfo: "Informe o tipo do animal",
    addVehicle: "Adicionar veículo",
    addVehicleInfo: "Informe os dados do veículo",
    cancel: "Cancelar",
    add: "Adicionar",
    maxGuestsAllowed: "Essa reserva permite até",
    companion: "acompanhante",
    companions: "acompanhantes",
    addCompanion: "Adicionar acompanhante",
    removeCompanion: "Remover acompanhante",
    thisReservationAllows: "Essa reserva permite",
    guestIndex: "Acompanhante {index}",
    documentFront: "Foto da frente do documento",
    documentBack: "Foto do verso do documento",
    faceSelfie: "Selfie do rosto",
    photoGuidelines: "Orientações para foto",
    followForBestResults: "Siga para melhores resultados",
    photoInWellLitPlace:
      "Fotografe em um local bem iluminado, evitando sombras ou reflexos sobre o documento.",
    centerDocument:
      "Centralize o documento na tela, mantendo todas as bordas visíveis e sem cortes.",
    holdPhoneSteady:
      "Segure o celular firme ou apoie-o em uma superfície para evitar fotos tremidas e garantir nitidez.",
    takePhoto: "Tirar foto",
    attachPhoto: "Anexar foto",
    selfieGuidelines: "Orientações para selfie do rosto",
    faceWellLit:
      "Fique de frente para uma fonte de luz natural ou ambiente bem iluminado para evitar sombras.",
    faceFramed:
      "Mantenha seu rosto inteiro dentro do enquadramento, olhando direto para a câmera.",
    removeAccessories:
      "Retire óculos escuros, bonés ou qualquer item que possa cobrir o rosto.",
    takeFaceSelfie: "Tirar selfie do rosto",
    selfiePreviewTitle: "Como ficou sua selfie?",
    selfiePreviewSubtitle: "Verifique a qualidade antes de continuar.",
    selfiePreviewQualityWarning:
      "Certifique-se de que o rosto está totalmente visível, com boa iluminação e sem acessórios que cubram o rosto.",
    selfiePreviewAccept: "Continuar com esta selfie",
    selfiePreviewRetake: "Refazer selfie",
  },

  navigation: {
    back: "Voltar",
    next: "Próximo",
  },

  validation: {
    required_birthDate: "Data de nascimento é obrigatória",
    invalidDate: "Data inválida",
    minimumAge: "O hóspede principal deve ter pelo menos 18 anos",
    requiredCheckOutTime: "A data de saída é obrigatória",
    requiredCheckInTime: "A data de entrada é obrigatória",
    TimeOutOfRange: "Horário indisponível",
    checkInOutOfRange: "Horário de CheckIn indisponível",
    checkOutOutOfRange: "Horário de CheckOut indisponível",
    required: "Este campo é obrigatório",
    email: "Email inválido",
    name: "Nome inválido",
    phone: "Número de telefone inválido",
    min_adults: "Deve haver pelo menos um adulto",
    children: "Número de crianças é obrigatório",
    validate_cpf: "CPF inválido",
    validate_phone: "Telefone inválido",
    required_cpf: "CPF é obrigatório",
    required_document: "Documento é obrigatório",
    alert: "Preencha todos os campos obrigatórios",
    checkout_greater_than_checkin:
      "Data e hora do checkout precisa ser após o checkin!",
    required_address: {
      cep: "CEP obrigatório",
      postalCode: "Código Postal obrigatório",
      country: "País é obrigatório",
      city: "Cidade é obrigatório",
      state: "Estado é obrigatório",
      number: "Número é obrigatório",
      street: "Rua é obrigatório",
    },
    vehicle: {
      missingVehicles: "Diga-nos quais veículos você pretende trazer.",
      missingWithVehicle: "Informe se você planeja vir com um veículo ou não.",
      missingVehicleType: "O tipo de veículo é obrigatório!",
      missingVehicleLicensePlate:
        "A placa, cor e modelo do veículo são obrigatórios!",
    },
    additionalGuestNameMissing:
      "O nome do hóspede adicional {nameOrIndex} é obrigatório",
    additionalInvalidCPF: "O CPF do hóspede adicional {nameOrIndex} é inválido",
    additionalInvalidPhone:
      "O Telefone do hóspede adicional {nameOrIndex} é inválido",
    missingAdditionalGuestBirthDate:
      "A data de nascimento do hóspede adicional {nameOrIndex} é obrigatória",
    additionalInvalidDocument:
      "O Documento do hóspede adicional {nameOrIndex} é inválido",
    additionalMissingDocumentFront:
      "Falta a Frontal do Documento do Hóspede adicional {nameOrIndex}",
    additionalMissingDocumentBack:
      "Falta o verso Documento do Hóspede adicional {nameOrIndex}",
    additionalMissingDocumentSelfie:
      "Falta a selfie do Hóspede adicional {nameOrIndex}",
    missingDocumentFront: "Falta a Frontal do Documento",
    missingDocumentBack: "Falta o verso Documento",
    missingDocumentDigital: "Falta o Documento Digital",
    missingDocumentSelfie: "Falta a Autenticação Facial!",
    missingVisitPurpose:
      "O propósito da visita ou a opção 'Não desejo informar' é obrigatório",
    addTheAdditionalGuests: "Adicione o hóspede adicional",
    mustAcceptAllTerms: "Você deve aceitar todos os termos para continuar",
    mustAcceptUserTerms: "Você deve aceitar os termos de uso para continuar",
  },

  residenceInfo: "Avisos Importantes",

  // ----------Doc----------
  doc: {
    tab1: "Documento<br>Físico (Fotos)",
    tab2: "Documento Digital<br>(Foto ou PDF)",
    front: "Frente do documento do hóspede responsável",
    back: "Verso do documento do hóspede responsável",
    pdf: "Anexar Documento Digital (PDF)",
    title1: "1. Envie uma foto da frente de seu documento",
    title2: "2. Envie uma foto do verso de seu documento",
    title3: "3. Agora vamos iniciar o processo da autenticação por Facial",
    title4: "1. Envie seu documento digital",
    title5: "2. Agora vamos iniciar o processo da autenticação por Facial",
    text1: "São aceitos documentos com foto como RG, CNH ou Passaporte.",
    text1_1:
      "Lembrando que se for RG ou CNH o documento normalmente fica <b>dobrado</b> dentro de uma capinha, então você deve retirar e desdobrá-lo para tirar a foto. Assim como está na imagem abaixo:",
    text2: "Envie uma foto do verso do documento que você enviou no campo 1.",
    text3:
      "O processo é bem simples, ao clicar em “Iniciar Autenticação” ative sua camera do celular e coloque seu rosto nas demarcações solicitadas.",
    text3_1:
      "Precisaremos de acesso à sua câmera. Caso esteja utilizando um computador sem webcam, você pode fazer esta etapa no seu smartphone.",
    text4: "Anexe seu documento digital, arquivo no qual tenha o QR Code ",
    missingDocs: "Envie todos os documentos solicitados!",
    missingSelfie: "Realize a autenticação por facial!",
    startAuthentication: "Iniciar Autenticação",
    authenticationAdditionalGuest: "Selfie hóspede adicional {nameOrIndex}",
    startAgainAuthentication: "Salvo. Fazer Novamente?",
  },

  readAndAccept: "Li e aceito",

  dontAccept: "Não aceito",

  // ---------Additional Guest-------
  additionalGuest: {
    notAllowedAdditionalGuests:
      "Não é permitido adicionar hóspedes adicionais para esta reserva.",
    add: "Adicionar novo",
    askReload:
      "Esta opção serve para obtenção dos dados preenchidos pelos próprios hospedes adicionais pelo link que você enviou. Você têm certeza?",
    reload: "Obter dados já preenchidos",
    fill: "Preencher Dados",
    view: "Ver Dados",
    del: "Apagar Hóspede Adicional",
    copy: "Enviar link de preenchimento",
    copied:
      "Link copiado com sucesso. Envie para o hóspede adicional preencher",
    heading: "Dados do Hóspede Adicional",
    name: "Nome completo do Hóspede",
    cpf: "CPF do Hóspede",
    passport: "Passaporte/RNE do Hóspede",
    isChild: "É criança ou menor de idade?",
    foreignCheckbox: "Estrangeiro?",
    document: "Documento do Hóspede (Frente) ou Documento Completo",
    documentBack: "Documento do Hóspede (Verso)",
    downloadDocument: "Ver Documento Frente ou Completo",
    downloadDocumentBack: "Ver Documento Verso",
    hasAdditional: "Tem algum hóspede adicional?",
    howManyAdditional: "Quantos hóspedes adicionais?",
    facialRecognitionInfo:
      "A autenticação é obrigatória para todos os hóspedes adicionais.",
    isntPossibleToAddAdditionalGuests:
      "Não é possivel adicionar hóspedes adicionais para essa reserva.",
    giveTheDipositiveToTheGuestMakeSelfie:
      "Por favor passe o dispositivo para o hóspede adicional fazer a selfie.",
    reloadedSuccess: "Dados dos hóspedes adicionais recarregados com sucesso!",
  },

  importPreviousReservationData: {
    importReservationData: "importar dados da reserva",
    sixDigitsCode: "Código de 6 dígitos",
    confirm: "Confirmar",
    resendCode: "Reenviar Código",
    await: "Aguarde",
    continueWithoutImport: "Continuar sem Importar",
    invalidDate: "Data inválida",
    close: "Fechar",
    errorSendingEmail: "Erro ao enviar email.",
    errorSendingWhatsApp: "Erro ao enviar WhatsApp.",
    errorSendingCode: "Erro ao enviar código.",
    dataImportedSuccessfully: "Dados importados com sucesso!",
    informSixDigitsCode: "Informe o código de 6 dígitos",
    youAlreadyIsOurClient:
      "Tomamos conhecimento que você já é se hospedou em uma agencia parceira da Selfie Checkin, gostaria de importar os dados de alguma das suas reservas antigas?",
    noInformedCompany: "Empresa não informada.",
    import: "Importar",
    previousReservations: "Reservas Anteriores",
  },
  goToPreviousReservation:
    "Você já tem uma reserva em andamento. Gostaria de ir a ela?",
  reservationInProgress: "Reserva em progresso",

  // ------------PIX-----------
  cautionPayment: {
    question: "Sua reserva possui caução?",
    cautionCoveredByAirCover:
      "Sua reserva está coberta pelo seguro Air cover do Airbnb!  Clique abaixo para avançar.",
    noCautionMessage: "Sua reserva não possui caução.",
    heading: "Caução",
    howItWorks: "Como funciona?",
    subheading: "Preencha com os dados da estadia",
    cautionValue: "O valor do caução para esta reserva é de: R$ {value}",
    cautionValueMessage:
      "Esse imóvel solicita o pagamento de caução no valor de <strong>{value}</strong>.",
    pixKeyLabel: "Chave pix",
    attachProof: "Anexar comprovante de pagamento",
    copied: "Chave Pix copiada com sucesso!",
    missingCautionPayment:
      "É necessário anexar o comprovante de pagamento do caução",
    downloadProof: "Baixar comprovante de pagamento",
    replaceProof: "Substituir comprovante de pagamento",
    selectMethod: "Selecione o método de pagamento",
    creditCard: "Cartão de Crédito (Pré-autorização)",
    pix: "Pix",
    insurance: "Seguro Check-in",
    bestOption: "MELHOR OPÇÃO",
    whatIsCaution: "O que é caução?",
    processedBy: "Processado por",
    paymentWindowError:
      "O pagamento da caução deverá ser feito entre os dias {startDate} e {endDate}.",
    preAuthLabel: "PRÉ AUTORIZAÇÃO",
    cardData: "Dados do cartão",
    cardNumber: "Número do cartão",
    cardHolder: "Nome no cartão",
    expirationMonth: "Mês",
    expirationYear: "Ano",
    cvv: "Código de segurança (CVV)",
    installments: "Parcelamento",
    preAuthWarning:
      "A pré-autorização ocorre até 30 dias antes do check-out. Verifique se há limite disponível no cartão nesse período.",
    billingAddress: "Endereço de cobrança",
    useReservationAddress: "Usar endereço preenchido na Reserva?",
    complement: "Complemento",
    zipCode: "CEP",
    city: "Cidade",
    state: "Estado",
    number: "Número",
    street: "Rua",
    missingPaymentMethod: "Selecione um método de pagamento para a caução",
    missingCardNumber: "Número do cartão é obrigatório",
    paymentRequired: "O pagamento da caução é obrigatório",
    missingCardHolder: "Nome no cartão é obrigatório",
    missingExpirationMonth: "Mês de expiração é obrigatório",
    missingExpirationYear: "Ano de expiração é obrigatório",
    missingCvv: "CVV é obrigatório",
    missingZipCode: "CEP é obrigatório",
    missingCity: "Cidade é obrigatória",
    missingState: "Estado é obrigatório",
    missingStreet: "Rua é obrigatória",
    missingAddressNumber: "Número é obrigatório",
    missingNeighborhood: "Bairro é obrigatório",
    pixModalTitle: "Pagamento da Caução",
    pixPaymentRealized: "Pagamento Realizado!",
    pixPaymentIdentifiedWait:
      "O pagamento foi identificado com sucesso. Aguarde um instante...",
    pixPaymentIdentified: "O pagamento foi identificado com sucesso.",
    pixModalDescription:
      "Escaneie o QR Code abaixo para realizar o pagamento via PIX. A confirmação é instantânea.",
    pixCopyPasteLabel: "Código Pix Copia e Cola",
    pixModalWarning:
      "Não feche esta página. O sistema avançará automaticamente após a confirmação do pagamento.",
    pixModalWaiting: "Aguardando confirmação do banco...",
    pixGeneratedNextStep:
      "Seu PIX será gerado na próxima etapa para pagamento imediato.",
    pixTimerMessage: "Você tem {minutes} minutos para concluir o pagamento.",
    pixExpired: "Pagamento não realizado",
    pixTryAgain: "Tente novamente",
    pollingTimeout:
      "O tempo para confirmação do pagamento expirou. Por favor, tente novamente.",
    comingSoon: "Em breve",
    apiErrors: {
      GUEST_NOT_FOUND: "Hóspede não encontrado.",
      NO_CAUTION_VALUE: "Não há valor de caução configurado para esta reserva.",
      INCOMPLETE_GUEST_DATA:
        "Dados incompletos. Preencha nome, e-mail, CPF e telefone antes de pagar.",
      INVALID_PHONE: "Telefone inválido. Verifique o número informado.",
      CAUTION_PERIOD_EXPIRED:
        "O período para pagamento da caução foi encerrado.",
      LONG_STAY_NO_CREDIT_CARD:
        "Pagamento via Cartão de Crédito não está disponível para reservas acima de 30 dias.",
      CREDIT_CARD_TOO_EARLY:
        "O pagamento via Cartão de Crédito é liberado apenas 30 dias antes do checkout.",
      CAUTION_PAYMENT_PENDING:
        "Pagamento da caução via cartão ainda não confirmado. Conclua o pagamento antes de finalizar.",
    },
    loadingPayment: "Carregando ambiente de pagamento seguro...",
    secureEnvironment: "Pagamento processado em ambiente seguro Pagar.me",
    paymentConfirmed: "Caução confirmada com sucesso!",
    alreadyPaidTitle: "Caução já paga",
    alreadyPaidSubtitle: "O pagamento da caução já foi realizado anteriormente. Você pode continuar sem pagar novamente.",
    iframeError: "Erro ao carregar pagamento. Tente novamente.",
    retryPayment: "Tentar novamente",
    confirmPreAuth: "Confirmar pré-autorização",
    cautionBlocked:
      "O período para pagamento da caução foi encerrado pois a reserva já passou da data de checkout.",
    longStayNoCreditCard:
      "Para reservas com mais de 30 dias, o pagamento da caução via Cartão de Crédito não está disponível. Por favor, utilize a opção PIX.",
    creditCardReleaseDateMessage:
      "O pagamento da caução via Cartão de Crédito é liberado 30 dias antes do dia do checkout - {date}",
  },
  talkOnWhatsApp: "Fale pelo WhatsApp",

  importantInfoBeforeContinue: "Informações importantes antes de continuar",

  acceptTermsAndConditions: "Eu aceito os termos e condições",
  acceptTermsOfImage: "Eu aceito os termos de uso da imagem",

  imageTermsContent: {
    title: "TERMOS DE USO / TERMOS DE USO DA IMAGEM",
    content: `Nós do "Selfie Check-in" levamos a sua privacidade e a proteção dos seus dados a sério. Por isso, criamos a nossa Política de Privacidade ("Política") para que você, nosso usuário, ("Usuários") possa verificar i) quais informações pessoais são coletadas; ii) como tais informações pessoais são usadas e compartilhadas e iii) quais os direitos de privacidade que nossos usuários possuem.

Nossa política se aplica quando você utiliza os nossos sites, preenche nossos formulários ou contrata nossos serviços.

Cookies são pequenos arquivos de texto (geralmente criptografados) que ficam armazenados nos navegadores após o usuário acessar um site. Por meio deles é possível identificar o dispositivo de acesso utilizado.

Ao acessar o site o usuário reconhece ser o único responsável pela veracidade, exatidão e autenticidade dos dados fornecidos, comprometendo-se, ainda, com a guarda, sigilo e boa utilização de eventual login e senha cadastrados.

DESCOMPLICANDO: TERMOS E CONCEITOS QUE VOCÊ PRECISA SABER

Criptografia
Criptografia é um mecanismo de segurança e privacidade usado para codificar e decodificar dados. Tem como objetivo proteger informações confidenciais de ameaças e acessos não autorizados.

Cookies

CRM
Sigla para o termo em inglês Customer Relationship Management, que pode ser traduzido para o português como Gestão de Relacionamento com o Cliente.

Dado Pessoal
É uma informação relacionada a uma pessoa física e que seja capaz de identificar a pessoa ou tornar possível a sua identificação.

IP (Internet Protocol)
É o Protocolo da Internet, que tem como objetivo identificar cada dispositivo conectado à rede por meio de uma numeração única.

Tratamento
É toda forma de uso que podemos fazer dos seus Dados Pessoais, incluindo, mas não se limitando às seguintes atividades: coleta, armazenamento, consulta, uso, compartilhamento, transmissão, classificação, reprodução, exclusão e avaliação.

Titular
É você, a pessoa física a quem os Dados Pessoais se referem.

QUANDO E QUAIS DADOS SÃO COLETADOS

O Selfie Check-in poderá coletar os dados sempre que houver interação ativa e voluntária do usuário ao se cadastrar no site e também através do uso dos nossos canais de comunicação, o que inclui: (a) WhatsApp corporativos (central do Selfie Check-in e atendimento de emergência), (b) comunicação via chats das plataformas (Airbnb, Booking, Expedia e outros), (c) contato via e-mail, (d) cadastro no site, (e) contato telefônico via linha fixa.

Dados de navegação dos visitantes do site
• Endereços de IP utilizados;
• Cliques; e
• Tempos de visita.

Esses dados são coletados através de "cookies" o que torna sua experiência on-line mais fácil, rápida e acessível, economizando informações de navegação.

Dados cadastrais
• Nome Completo
• E-mail
• CNH
• RNE para usuários estrangeiros
• Passaporte para usuários estrangeiros
• Sexo
• Data de nascimento
• CPF
• Nacionalidade
• Idioma
• RG
• Celular
• CEP
• Endereço
• Cidade/Estado
• Senha
• Certidão de nascimento para menores

Dados de pagamento
• Dados Bancários
• Forma de pagamento cartão de crédito, pix, PayPal ou transferência bancária)

Além dos instrumentos de pagamento utilizados, também poderão ser coletados data e hora, valor do pagamento, data de vencimento do instrumento de pagamento e código postal de cobrança, endereço de e-mail do PayPal, endereço do usuário e outras informações relacionadas à transação, como forma de proteção e repressão a fraude.

Documentos coletados
Para a realização e finalização das reservas, é necessário o envio dos seguintes documentos:
• Foto do documento de identificação frente e verso: RG, CNH, RNE e passaporte para usuários estrangeiros;
• Certidão de nascimento, ou outro documento oficial que mostre o vínculo, em caso de menores (Conforme disposto na Lei nº 8.069/1990, para a realização da reserva é necessária a apresentação do documento de identificação do menor.)
• Foto do titular da reserva com o documento em mãos.

FINALIDADE DA COLETA DOS DADOS

Os dados pessoais coletados poderão ser utilizados das seguintes formas:
✔ Para viabilizar o uso e experiência dos serviços contratados;
✔ Para efetuar estatísticas, estudos, pesquisas e levantamentos pertinentes às atividades e comportamento no uso dos Serviços, realizando tais operações de forma anonimizada;
✔ Para permitir sua participação em promoções e divulgação de materiais de marketing;
✔ Para processar pagamento e viabilizar a prestação do serviço oferecido pelo site;
✔ Para Comunicação, podendo ser enviados avisos e notificações importantes relacionados ao usuário, como alterações dessa Política, novos produtos/serviços e pesquisas de satisfação;
✔ Cumprimento de obrigação legal e defesa de direitos, podendo ser utilizados para fins de cumprimento de obrigação legal ou regulatória, bem como para defesa de direitos em conflitos judiciais ou extrajudiciais;
✔ Para efetuar o pagamento dos produtos que o usuário selecionou; Para responder as solicitações do usuário;
✔ Para implementar e proporcionar melhorias/aperfeiçoamentos da própria prestação dos serviços.

COMPARTILHAMENTO DE DADOS

O compartilhamento dos dados pessoais dos usuários será realizado sempre dentro dos limites legais, observando-se especialmente o que determina a Lei nº 13.709/2018 ("LGPD"), sempre considerando os propósitos da relação entre o site e o usuário e negócio desenvolvido pelo "Selfie Check-in".

Os dados pessoais dos usuários podem ser compartilhados com empresas do mesmo grupo, empresas subsidiárias, afiliadas parceiros, fornecedores, e provedores de serviços, para finalidades legítimas da seguinte maneira:
✔ Para condução das atividades de tratamento de dados pessoais acima descritas, inclusive o armazenamento dos dados pessoais coletados;
✔ Para cumprir obrigações legais, regulatórias ou contratuais;
✔ Para exercício de legítimo interesse;
✔ Como meio de evitar fraude fraudes e proteger os dados dos usuários

Os parceiros somente são autorizados a utilizar os dados pessoais para os fins a que foram contratados, sendo vedada a utilização dos dados pessoais dos usuários para outras finalidades que não as da prestação de serviços previstas contratualmente.

ARMAZENAMENTO DOS DADOS

Os dados pessoais dos usuários serão armazenados apenas pelo tempo necessário para que sejam atingidas as finalidades aqui apresentadas.

Para fins de auditoria e preservação dos direitos dos usuários, os dados poderão ser armazenados pelo período máximo de 5 (cinco) anos contados a partir do cancelamento de eventual conta de acesso, podendo ser estendido por prazo maior nas hipóteses em que a lei ou norma regulatória assim estabelecer ou para preservação de direitos.

TRATAMENTO DE DADOS SENSÍVEIS – RECONHECIMENTO FACIAL

No âmbito da prestação dos serviços, a Selfie Check-in poderá realizar o tratamento de dados biométricos (imagens faciais) para fins de verificação de identidade e prevenção de fraudes no processo de check-in.

Esses dados são classificados como dados pessoais sensíveis, conforme previsto no art. 5º, II, da LGPD. O tratamento será realizado com estrita observância às bases legais previstas no art. 11 da LGPD, em especial:

Para cumprimento de obrigação legal ou regulatória, quando aplicável;

O reconhecimento facial será utilizado exclusivamente para verificar a identidade do hóspede e garantir a segurança da hospedagem, não sendo empregado para qualquer outra finalidade incompatível.

As informações biométricas coletadas serão armazenadas em ambiente seguro, com uso de criptografia, controle de acesso restrito e logs de auditoria, sendo descartadas ou anonimizadas tão logo cumprida a finalidade para a qual foram obtidas, respeitados os prazos legais.

O titular poderá a qualquer tempo revogar o consentimento fornecido para esse tratamento, por meio de solicitação ao Encarregado (DPO), ciente de que a revogação poderá inviabilizar a realização do check-in automatizado.

DIREITO DOS USUÁRIOS

Nos termos da LGPD, os usuários possuem direitos e garantias em relação aos seus dados. Nós disponibilizamos mecanismos, detalhados abaixo, para que nosso usuário tenha clareza e transparência no exercício de seus direitos.

Os usuários poderão:
✔ Requisitar detalhes e/ou cópia dos seus dados armazenados pelo Selfie Check-in;
✔ Alterar ou corrigir seus dados, mediante solicitação por email ou whatsapp;
✔ Confirmar a existência de tratamento dos dados;
✔ Corrigir os dados incompletos, inexatos ou desatualizados;
✔ Manter a anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na LGPD;
✔ Solicitar a portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa, de acordo com a regulamentação da Autoridade Nacional, observados os segredos comercial e industrial;
✔ Eliminar os dados pessoais tratados com o consentimento do(a) titular, exceto nas hipóteses previstas no art. 16 da Lei;
✔ Solicitar informações das entidades públicas e privadas com as quais o Controlador realizou uso compartilhado de dados;
✔ Solicitar informações sobre a possibilidade de não fornecer consentimento e sobre consequências da negativa;
✔ Solicitar revogação do consentimento, nos termos do § 5.º do art. 8.º da Lei.

Para exercer todos os seus direitos ou esclarecer qualquer dúvida, entre em contato com contato{'@'}selfiecheckin.com.br

PROTEÇÃO DOS DADOS

O Selfie Check-in armazena os dados em ambientes operacionais que usam medidas de segurança técnicas e administrativas para prevenir qualquer tipo de acesso não autorizado e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão, utilizando tecnologias e procedimentos de segurança para ajudar a proteger os dados pessoais contra acessos indevidos, como por exemplo, a utilização da tecnologia de dois fatores para acessar o sistema, devendo o usuário configurar tal dispositivo de segurança.

Todos os dados coletados são armazenados em ambiente seguro e controlado, pelo prazo mínimo de 6 (seis) meses, nos termos do Marco Civil da Internet.

Os dados podem ser armazenados em nossos servidores próprios ou de terceiro contratado para esse fim, sejam eles alocados no Brasil ou no exterior, de acordo com a LGPD.

A Selfie Check-in poderá disponibilizar aos proprietários/anfitriões mecanismos para registrar avaliações e comentários a respeito da hospedagem realizada pelos usuários. Essas avaliações poderão conter informações sobre o comportamento, cumprimento das regras do imóvel e histórico da estadia, constituindo dados pessoais vinculados ao titular.

O tratamento desses dados tem como finalidades:
assegurar maior transparência e segurança na relação entre hóspedes e anfitriões;
permitir a manutenção de um ambiente confiável na plataforma;
subsidiar eventuais medidas de prevenção a fraudes ou violações contratuais.

As avaliações permanecerão armazenadas pelo prazo necessário ao cumprimento dessas finalidades, podendo ser acessadas pelos respectivos proprietários e, quando aplicável, utilizadas pela Selfie Check-in para análise estatística ou melhoria dos serviços.

PLATAFORMAS SUJEITAS AO COMPARTILHAMENTO DOS DADOS

1. Cloud, AWS
2. Stripe
3. D4S Serviços em Tecnologia
4. Airbnb
5. Booking
6. Expedia
7. TripAdvisor
8. Responsáveis por limpeza/manutenção/portaria/zeladores/caseiros (PF)
9. Proprietários (PF)
10. Equipe Selfie Check-in
11. Paypal
12. Meta (Facebook, Instagram, Whatsapp)
13. Google (gmail, Google drive)
14. Microsoft (Outlook, Teams, One Drive)
15. Sistemas de Portaria.

Promoções e Benefícios de Parceiros

A nossa plataforma pode disponibilizar ao cliente informações sobre promoções, descontos e benefícios oferecidos por parceiros, tais como serviços de aluguer de automóveis, reservas de alojamento, transportes ou outras atividades relacionadas.

O acesso a estas promoções ocorre exclusivamente por iniciativa do cliente, através de links ou redirecionamentos para os websites ou aplicações dos respetivos parceiros.

Importa esclarecer que:
• Não ocorre qualquer partilha de dados pessoais entre a nossa plataforma e os parceiros no momento do acesso.
• A eventual recolha e tratamento de dados pessoais passa a ser regida exclusivamente pela política de privacidade do parceiro, a qual recomendamos que seja consultada antes de prosseguir com a utilização do serviço.
• A nossa plataforma limita-se a disponibilizar a informação sobre a promoção, sem qualquer intervenção no processamento de dados pessoais ou na prestação do serviço contratado junto do parceiro.

ALTERAÇÕES DESTA POLÍTICA

As disposições desta Política podem ser alteradas a qualquer tempo. Sempre que a Política for alterada, essas alterações serão divulgadas no website da Plataforma e poderão ser enviadas por e-mail.

CONTATO

Qualquer dúvida envolvendo privacidade poderá ser enviada ao Encarregado pelo Tratamento de Dados (DPO) da Selfie Check-in, através do e-mail: dpo{'@'}selfiecheckin.com.br

Compartilhamento de dados: poderá ocorrer com processadores de pagamento

Última Modificação: outubro 2026

A Selfie Check-in realiza o tratamento de (ex.: PayPal, Stripe), provedores de serviços de hospedagem em nuvem, dados pessoais em estrita observância à Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD) e às diretrizes da Autoridade Nacional de Proteção de Dados (ANPD). O ciclo de vida dos dados compreende a coleta, armazenamento, utilização, compartilhamento e posterior eliminação ou anonimização, observados os prazos legais e finalidades específicas.

Dados coletados: nome completo, documentos de identificação (RG/CPF, passaporte), endereço, telefone, e-mail, dados bancários e de pagamento, fotografia/perfil, informações de histórico de comportamento e avaliações, bem como dados de geolocalização durante o check-in/check-out, quando aplicável.

provedores de e-mail, serviços de análise de risco de fraude, autoridades públicas quando necessário, e parceiros contratados para execução dos serviços.

Segurança: são adotadas medidas técnicas e administrativas adequadas, incluindo criptografia em repouso e em trânsito, autenticação multifator, registros de log de acesso, firewalls, antivírus e rotinas periódicas de backup, com controle de acesso restrito a administradores, moderadores e suporte técnico.

Direitos dos titulares: os usuários poderão exercer os direitos previstos no art. 18 da LGPD (acesso, correção, exclusão, anonimização, bloqueio, portabilidade, revogação de consentimento, entre outros) mediante solicitação ao Encarregado (DPO) pelo canal indicado nesta Política`,
  },

  termsOfUseContent: {
    title: "TERMOS E CONDIÇÕES DE USO – SELFIE CHECK-IN",
    content: `1. Aceitação dos Termos

Ao aceder e utilizar a plataforma Selfie Check-in, o utilizador declara que leu, compreendeu e concorda em cumprir integralmente os presentes Termos de Uso, bem como a Política de Privacidade disponível no site.

2. Objeto

A Selfie Check-in disponibiliza uma plataforma digital destinada a facilitar processos de check-in automatizado em imóveis de alojamento, permitindo a recolha e validação de dados de hóspedes, comunicação com proprietários/anfitriões e gestão de reservas.

3. Condições de Utilização

- O utilizador compromete-se a fornecer informações verdadeiras, completas e atualizadas.
- O uso da plataforma é restrito a maiores de 18 anos ou menores devidamente autorizados pelos representantes legais.
- É proibida qualquer utilização ilícita, fraudulenta ou que possa comprometer a segurança da plataforma ou de terceiros.

4. Registo e Conta de Utilizador

- Para aceder a determinadas funcionalidades, o utilizador poderá ter de criar uma conta, escolhendo credenciais de acesso (login e palavra-passe).
- O utilizador é responsável pela confidencialidade das suas credenciais e por todas as atividades realizadas na sua conta.
- A Selfie Check-in reserva-se o direito de suspender ou cancelar contas que violem os presentes Termos.

5. Dados Pessoais e Privacidade

- O tratamento de dados pessoais, incluindo dados sensíveis (ex.: biometria facial), rege-se pela Política de Privacidade da Selfie Check-in, elaborada em conformidade com a LGPD (Lei n.º 13.709/2018).
- O utilizador declara estar ciente de que determinadas funcionalidades (ex.: reconhecimento facial para prevenção de fraudes) dependem do fornecimento de consentimento expresso.

6. Responsabilidades da Selfie Check-in

A Selfie Check-in compromete-se a:

- Garantir o funcionamento regular da plataforma, salvo em situações de manutenção, atualização ou força maior;
- Proteger os dados pessoais dos utilizadores, adotando medidas técnicas e administrativas adequadas;
- Cumprir com a legislação aplicável em matéria de privacidade, proteção de dados e defesa do consumidor.

7. Responsabilidades do Utilizador

O utilizador compromete-se a:

- Utilizar a plataforma apenas para os fins legalmente permitidos;
- Não reproduzir, copiar, distribuir ou modificar qualquer parte da plataforma sem autorização prévia;
- Não aceder a áreas restritas ou a sistemas da Selfie Check-in por meios não autorizados.

8. Propriedade Intelectual

Todos os conteúdos da plataforma (marcas, logótipos, software, textos, imagens e design) são propriedade da Selfie Check-in ou de terceiros licenciadores, sendo proibida a sua utilização sem autorização expressa.

9. Limitação de Responsabilidade

- A Selfie Check-in não se responsabiliza por danos decorrentes de falhas na conexão de internet, sistemas de terceiros ou utilização indevida da plataforma.
- A responsabilidade da Selfie Check-in restringe-se aos serviços por si prestados, nos limites legalmente permitidos.

10. Alterações aos Termos de Uso

A Selfie Check-in poderá alterar estes Termos de Uso a qualquer momento. As alterações serão publicadas no site e entrarão em vigor na data da sua divulgação. A continuação da utilização da plataforma implica a aceitação das novas condições.

11. Contacto

Para qualquer dúvida sobre os presentes Termos de Uso, o utilizador poderá contactar a Selfie Check-in através do e-mail: contato{'@'}selfiecheckin.com.br

12. Lei Aplicável e Foro

Estes Termos de Uso regem-se pela legislação brasileira (LGPD e normas de defesa do consumidor), ficando eleito o foro da comarca da sede da Selfie Check-in para resolução de eventuais conflitos, salvo competência legal diversa.`,
  },
  homeV2: {
    hero: {
      titleLine1: "Toda a jornada do hóspede.",
      titleLine2: "Uma plataforma.",
      subtitle: "Automação, segurança e IA para conectar sua operação, da reserva ao pós-estadia.",
      ctaPrimary: "Conheça mais",
      ctaSecondary: "Fale com a nossa equipe",
      mockupAlt: "Painel da Selfie Check-in com reservas, check-ins pendentes e status de cada hóspede",
    },
    logos: {
      label: "Plataformas integradas",
    },
    pillars: {
      titleLead: "A hospitalidade é sua.",
      titleAccent: "A conexão fica com a Selfie.",
      lead: "Documentos para conferir, mensagens para responder e acessos para coordenar. Reúna as etapas da hospedagem para acompanhar cada reserva com mais organização.",
      automation: {
        title: "Automação que acompanha a reserva.",
        text: "Check-in digital, notificações e integrações conectam as informações do hóspede ao dia a dia da operação.",
      },
      security: {
        title: "Segurança para decidir com contexto.",
        text: "Documentos, selfie e validações reúnem informações para apoiar a análise da chegada. Caução e assinatura eletrônica complementam a jornada.",
      },
      ai: {
        title: "IA presente ao longo da estadia.",
        text: "Um agente apoia o check-in, responde dúvidas sobre o imóvel e direciona situações que precisam de atendimento humano.",
      },
    },
    journey: {
      titleLine1: "Uma jornada completa.",
      titleAccent: "Etapas",
      titleAfter: " conectadas.",
      lead: "Do primeiro contato ao histórico da estadia, cada etapa prepara a próxima.",
      step1: {
        title: "Reserva",
        text: "O anfitrião cadastra o imóvel e os dados da reserva para iniciar a jornada do hóspede na plataforma.",
      },
      step2: {
        title: "Comunicação",
        text: "O hóspede recebe as orientações da hospedagem e o link para fazer o check-in digital antes da chegada.",
      },
      step3: {
        title: "Check-in",
        text: "O hóspede preenche seus dados e envia os documentos e uma selfie pelo formulário digital.",
      },
      step4: {
        title: "Validação",
        text: "Os dados são verificados e é realizada uma consulta de antecedentes criminais via SERPRO. Se houver registro, o anfitrião é avisado para avaliar a hospedagem.",
      },
      step5: {
        title: "Caução",
        text: "A caução oferece uma garantia financeira para eventuais danos, trazendo mais segurança ao anfitrião conforme as condições acordadas para a hospedagem.",
      },
      step6: {
        title: "Acesso",
        text: "Após a aprovação, a portaria recebe as informações para a entrada. O acesso por fechaduras inteligentes pode ser automatizado conforme a integração disponível.",
      },
      step7: {
        title: "Estadia",
        text: "O hóspede acessa o Guia do Hóspede, com orientações sobre o imóvel e dicas da região, e conta com atendimento durante a estadia.",
      },
      step8: {
        title: "Pós-check-out",
        text: "Os dados da reserva, do check-in e o histórico da estadia ficam registrados para futuras consultas. O hóspede pode ser convidado a avaliar sua experiência.",
      },
    },
    ai: {
      badge: "Inteligência artificial",
      title: "Um agente de IA que te ajuda no gerenciamento das estadias",
      lead: "A tecnologia te apoia enquanto você foca no que realmente importa.",
      phoneAlt: "Tela de mensagens da Selfie Check-in com o chatbot atendendo hóspedes",
      before: {
        title: "Antes da chegada",
        text: "Coleta informações e acompanha o andamento do check-in.",
      },
      during: {
        title: "Durante a hospedagem",
        text: "Responde dúvidas usando informações do imóvel.",
      },
      after: {
        title: "Depois do check-out",
        text: "Pode solicitar a avaliação do hóspede.",
      },
      human: {
        title: "Quando precisa de uma pessoa",
        text: "Direciona situações ao atendimento humano.",
      },
    },
    checkin: {
      eyebrow: "Reserva e cadastro",
      title: "Check-in digital antes da chegada e validação de identidade",
      photoAlt: "Hóspede tirando uma selfie com o celular na porta do imóvel",
      document: {
        title: "Documento",
        text: "Conferência dos dados enviados pelo hóspede.",
      },
      selfie: {
        title: "Selfie",
        text: "Comparação facial com o documento apresentado.",
      },
      verification: {
        title: "Verificação de segurança",
        text: "Consulta de dados oficiais via SERPRO.",
      },
    },
    integrations: {
      eyebrow: "Uma operação mais alinhada",
      title: "Conexão entre todos os pontos de contato",
      lead: "Anfitrião, administradora, proprietários e portaria: informações compartilhadas para preparar a chegada e acompanhar a reserva.",
      hostPhotoAlt: "Anfitrião consultando a reserva pelo celular",
      gatePhotoAlt: "Porteiro acompanhando as câmeras e a ficha da reserva na portaria",
      pms: {
        title: "Reservas e PMS",
        text: "Conexão com gestores de reservas para apoiar o fluxo da hospedagem.",
      },
      gate: {
        title: "Portarias e condomínios",
        text: "Confirmação e ficha da reserva após a aprovação, com integração ao condomínio quando compatível.",
      },
      locks: {
        title: "Fechaduras inteligentes",
        text: "Automação de acesso conforme a integração disponível.",
      },
      messaging: {
        title: "WhatsApp e e-mail",
        text: "Notificações que mantêm os envolvidos informados sobre a reserva e o check-in.",
      },
    },
    testimonials: {
      title: "A Selfie Check-in já está na rotina de quem hospeda",
      lead: "Mais organização para quem recebe, mais cuidado com quem chega. Veja como a Selfie Check-in pode simplificar a rotina e abrir espaço para o que importa: receber bem.",
      feature: "Menos tarefas manuais na gestão das hospedagens.",
      mario: {
        name: "Mario Costa",
        role: "Anfitrião de apartamentos por temporada",
        quote: "“Antes, eu precisava pedir documentos e acompanhar cada informação pelo WhatsApp. Com a Selfie Check-in, o hóspede envia tudo pelo formulário e eu consigo acompanhar o que falta antes da chegada. Minha rotina ficou mais organizada.”",
      },
      rafael: {
        name: "Rafael Almeida",
        role: "Administrador de imóveis de temporada",
        quote: "“Uma das partes mais trabalhosas era alinhar a chegada com a portaria. Com a Selfie, as informações da reserva chegam aos envolvidos após a aprovação. Isso facilitou a comunicação e diminuiu aquele vai e vem de mensagens.”",
      },
      bruna: {
        name: "Bruna Martins",
        role: "Anfitriã de casas de férias",
        quote: "“Os hóspedes costumam ter dúvidas parecidas sobre o imóvel. Ter um guia e o apoio da IA no atendimento me ajuda a responder essas questões e dedicar mais atenção às situações que precisam de mim.”",
      },
    },
    faq: {
      eyebrow: "Perguntas frequentes",
      title: "Perguntas que todo anfitrião faz",
      q1: {
        question: "Como funciona o check-in digital para o hóspede?",
        answer: "O hóspede recebe um link e preenche um formulário com seus dados, documentos e uma selfie antes da chegada. A operação acompanha o envio e a validação das informações para preparar a entrada.",
      },
      q2: {
        question: "Como a Selfie Check-in ajuda na validação da identidade dos hóspedes?",
        answer: "A plataforma reúne a conferência do documento, a comparação facial com a selfie e consultas disponíveis conforme a configuração contratada. Essas informações apoiam a análise e a decisão do anfitrião.",
      },
      q3: {
        question: "O que o agente de IA pode responder e quando o atendimento passa para uma pessoa?",
        answer: "O agente pode apoiar o preenchimento do check-in e responder dúvidas usando as informações do imóvel. Quando a situação exige atenção humana, direciona o atendimento para a equipe responsável.",
      },
      q4: {
        question: "A plataforma se integra ao meu sistema de reservas, à portaria e às fechaduras inteligentes?",
        answer: "A Selfie Check-in oferece integrações para conectar essas etapas da operação. A compatibilidade com os sistemas que você utiliza e as possibilidades de automação são verificadas durante a implantação.",
      },
      q5: {
        question: "Como funcionam a caução e a assinatura eletrônica?",
        answer: "A plataforma permite incorporar a caução à jornada e formalizar documentos da hospedagem com assinatura eletrônica. Os meios de pagamento, as condições da garantia e as regras de liberação são definidos na configuração da operação.",
      },
      q6: {
        question: "O que preciso para começar a usar a Selfie Check-in nos meus imóveis?",
        answer: "Entre em contato com a equipe para conhecer a plataforma e apresentar sua operação. Na implantação, são alinhados o cadastro dos imóveis, os recursos contratados e as integrações compatíveis com os sistemas que você já utiliza.",
      },
    },
    footer: {
      home: "Início",
      about: "Sobre",
      plans: "Planos",
      contact: "Contato",
      addressLine1: "Rua Tupi - Nº228, Santa Cecília São Paulo - SP",
      addressLine2: "CEP - 01233-000 {'|'} CNPJ - 56.107.848/0001-79",
      terms: "Termos e Condições de Uso",
      imageTerms: "Termos de Uso / Termos de Uso da Imagem",
    },
  },
};

export default pt;
